import React, { Component } from 'react'

export default class AssistanceTable extends Component {
  render() {
    return (
      <div>AssistanceTable</div>
    )
  }
}
